module.exports = __webpack_public_path__ + "img/oscar.0fffa242.svg";